import { input } from '@b2b/types/core';
import { Maskito, MaskitoOptions, maskitoTransform } from '@maskito/core';
import angular, { INgModelController } from 'angular';

MaskDirective.$inject = [];

function MaskDirective() {
  class MaskOptionsController {
    static $inject = ['$element'];

    mask: Maskito | null = null;
    maskOptions = input<MaskitoOptions>();
    maskValue = input<{ unmasked: string; masked: string }>();

    ngModel!: string;
    ngModelCtrl!: INgModelController;

    constructor(private $element: JQuery) {}

    $postLink() {
      const input = this.$element.get(0) as HTMLInputElement;

      if (input == null || this.maskOptions == null) {
        return;
      }

      this.mask = new Maskito(input, this.maskOptions);

      const handler = () => {
        this.ngModelCtrl.$setViewValue(this.maskValue?.unmasked ?? '');
      };

      this.$element.on('input', handler);
      this.$element.on('change', handler);
      this.$element.on('blur', handler);

      /**
       * Makes sure the input is masked after an input has been re-rendered.
       * e.g. a form was removed by ng-if and later added back to the page
       */
      this.ngModelCtrl.$formatters.push((value) => {
        if (this.maskOptions) {
          return maskitoTransform(this.ngModel ?? '', this.maskOptions);
        }

        return value;
      });
    }

    $onDestroy() {
      this.mask?.destroy();
      this.mask = null;
    }
  }

  return {
    restrict: 'A',
    controllerAs: '$maskCtrl',
    controller: MaskOptionsController,
    require: {
      ngModelCtrl: 'ngModel',
    },
    bindToController: {
      ngModel: '<',
      maskOptions: '<',
      maskValue: '<',
    },
  };
}

export const MaskDirectiveModule = angular
  .module('acme.common.directive.mask', [])
  .directive('acmeMask', MaskDirective).name;
